import React, { useEffect, useState } from 'react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      const finalCta = document.getElementById('final-cta');
      if (finalCta) {
        const rect = finalCta.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom >= 0) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full z-50 p-4 lg:hidden transition-transform duration-300 bg-white" style={{
    boxShadow: '0 -4px 20px rgba(0,0,0,0.08)'
  }} data-id="element-388">
      <a href="tel:4805998442" className="block w-full text-center" style={{
      backgroundColor: '#F27A3A',
      color: '#FFFFFF',
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontWeight: 700,
      fontSize: '16px',
      padding: '16px 20px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(242,122,58,0.2)'
    }} data-id="element-389">
        Claim 67% Off — Only $167
      </a>
    </div>;
}